<div class="row justify-content-between no-gutters">
  <div class="header-text">
    <div class=" header-title">{{ title }}</div>
    <div class="header-subtitle">
      {{ subtitle }}
    </div>
  </div>
  <div class="add-city" *ngIf="button == 'add-city'" (click)="openCity()"></div>
  <div
    class="add-venue"
    *ngIf="button == 'add-venue'"
    (click)="openVenue()"
  ></div>
</div>
